import { DRAFT } from '../../../constants/draft.constants';
import { getScoreLabel } from './helpers/getScoreLabel';

export default function DialogHeader({
  analysisResult,
}: {
  analysisResult: any;
}) {
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'row',
        gap: '0.5rem',
        width: '100%',
        justifyContent: 'center',
        alignItems: 'center',
      }}
      className={`OVERALL__SCORE__HEADER`}
    >
      <span>{DRAFT.ANALYSIS_DIALOG.OVERALL_SCORE}</span>
      <span>{Math.round(analysisResult.overall_score as number)}/100</span>
      <span>{getScoreLabel(analysisResult.overall_score as number)}</span>
    </div>
  );
}
